import React from 'react';
import SealRow from 'components/SealRow';
import formatRands from 'functions/formatRands.func';
import LevelTrack from './LevelTrack';
import sortSealsByAchieved from './sortSealsByAchieved';

const LevelProgress = ({ levels, currentLevel, nextLevel, seals }) => {
  const sealsToGo = nextLevel?.seals_remaining ?? 0;
  const sealWord = sealsToGo === 1 ? 'seal' : 'seals';
  const couponValue = nextLevel ? formatRands(nextLevel.coupon_value) : '';

  return (
    <div className="level-progress">
      <div className="level-progress__next">
        {nextLevel ? (
          <div className="level-progress__next-title">Next Status Level</div>
        ) : null}
        <div className="level-progress__next-name">
          {nextLevel ? nextLevel.name : 'Top Level Achieved'}
        </div>
      </div>

      <LevelTrack
        levels={levels}
        currentLevel={currentLevel.level}
        nextLevel={nextLevel}
      />

      {nextLevel ? (
        <p className="level-progress__reward">
          {`Unlock ${sealsToGo} more ${sealWord}`}
          <br />
          {'and receive a '}
          <strong>{couponValue}</strong>
          {' coupon!'}
        </p>
      ) : null}

      <ul className="level-progress__seals">
        {sortSealsByAchieved(seals).map((seal) => (
          <SealRow
            key={seal.key}
            sealKey={seal.key}
            name={seal.name}
            isAchieved={seal.achieved}
          />
        ))}
      </ul>
    </div>
  );
};

export default LevelProgress;
